/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightExchangeConsentRequest
 */
export interface FlightExchangeConsentRequest {
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConsentRequest
   */
  paymentMethodId: string;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConsentRequest
   */
  expectedDigest: string;
  /**
   * Explicit acknowledgment of the exact quoted terms; not payment authorization.
   * @type {boolean}
   * @memberof FlightExchangeConsentRequest
   */
  confirmed: boolean;
  /**
   *
   * @type {string}
   * @memberof FlightExchangeConsentRequest
   */
  acceptedPricingDisclosure?: string | null;
}

/**
 * Check if a given object implements the FlightExchangeConsentRequest interface.
 */
export function instanceOfFlightExchangeConsentRequest(
  value: object
): value is FlightExchangeConsentRequest {
  if (!("paymentMethodId" in value) || value["paymentMethodId"] === undefined)
    return false;
  if (!("expectedDigest" in value) || value["expectedDigest"] === undefined)
    return false;
  if (!("confirmed" in value) || value["confirmed"] === undefined) return false;
  return true;
}

export function FlightExchangeConsentRequestFromJSON(
  json: any
): FlightExchangeConsentRequest {
  return FlightExchangeConsentRequestFromJSONTyped(json, false);
}

export function FlightExchangeConsentRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightExchangeConsentRequest {
  if (json == null) {
    return json;
  }
  return {
    paymentMethodId: json["payment_method_id"],
    expectedDigest: json["expected_digest"],
    confirmed: json["confirmed"],
    acceptedPricingDisclosure:
      json["accepted_pricing_disclosure"] == null
        ? undefined
        : json["accepted_pricing_disclosure"],
  };
}

export function FlightExchangeConsentRequestToJSON(
  json: any
): FlightExchangeConsentRequest {
  return FlightExchangeConsentRequestToJSONTyped(json, false);
}

export function FlightExchangeConsentRequestToJSONTyped(
  value?: FlightExchangeConsentRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    payment_method_id: value["paymentMethodId"],
    expected_digest: value["expectedDigest"],
    confirmed: value["confirmed"],
    accepted_pricing_disclosure: value["acceptedPricingDisclosure"],
  };
}
